import { render, staticRenderFns } from "./DerbyPlayerRaces.vue?vue&type=template&id=33f6c12a&"
import script from "./DerbyPlayerRaces.vue?vue&type=script&lang=js&"
export * from "./DerbyPlayerRaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports